import { Alert, Collapse, Icon } from "@mui/material";

import useNetworkStatus from "~/hooks/useNetworkStatus";

/** Inline banner shown when the device is offline. Collapses away once connectivity returns. */
const OfflineBanner = () => {
	const { isOnline } = useNetworkStatus();

	return (
		<Collapse in={!isOnline}>
			<Alert icon={<Icon sx={{ fontSize: 20 }}>cloud_off</Icon>} severity="warning" sx={{ borderRadius: 0 }}>
				You are offline. Changes are saved and will sync when the connection is restored.
			</Alert>
		</Collapse>
	);
};

export default OfflineBanner;
